import { IPaymentMethod, ISubscriberVatInfo } from "@/common/api/unifiedPortal/interfaces";
import { paymentTypes } from "@/components/Buy/BuyEnums";
import { pageState as subscriptionPageState } from "@/globalEnums";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useSubscriptionPageStore = defineStore("subscriptionPage", () => {
  const computerIdToAutoRenew = ref<number>(-1);
  const paymentMethods = ref<IPaymentMethod[]>([]);
  const defaultCreditCard = ref<IPaymentMethod | null>(null);
  const showSpinner = ref<boolean>(true);
  const vatInfo = ref<ISubscriberVatInfo>();
  const vatInfoChanged = ref<boolean>(true);
  const isRemovingVat = ref<boolean>(false);
  const showAddVatNumberModal = ref<boolean>(false);
  const pageState = ref<subscriptionPageState>(subscriptionPageState.default);
  const addPaymentPreviousState = ref<subscriptionPageState>(subscriptionPageState.default);
  const currentPaymentType = ref<paymentTypes>(paymentTypes.CreditCard);

  const showApplyActivationCodeModal = ref<boolean>(false);
  const sortColumn = ref<string>("");
  const sortDirection = ref<Record<string, string>>({
    sku: "ascend",
    cardType: "",
    customExpirationDate: "",
  });

  return {
    computerIdToAutoRenew,
    paymentMethods,
    defaultCreditCard,
    showSpinner,
    vatInfo,
    sortColumn,
    sortDirection,
    showAddVatNumberModal,
    showApplyActivationCodeModal,
    pageState,
    addPaymentPreviousState,
    currentPaymentType,
    vatInfoChanged,
    isRemovingVat,
  };
});
